import { ModelPromoted } from "api"
import { Desktop, Mobile } from "common/MediaQueries"
import { useInView } from "react-intersection-observer"
import styled from "styled-components"
import { A11y, Keyboard } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import { HomePageContainer } from "theme/shared"
import ToolsCard from "./ToolsCard"

const StyledWrapperContainer = styled(HomePageContainer)<{ $inView: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 80px 20px;
  overflow: hidden;
  ${(p) => p.theme.breakpoints.up("md")} {
    padding: 100px 0px;
    max-width: 100vw;
    transition: all 0.9s 0.9s cubic-bezier(0.19, 0.88, 0.53, 1.12);
    transform: ${({ $inView }) =>
      $inView ? "translate3d(0, 0, 0)" : "translate3d(0, -85px, 0)"};
    opacity: ${({ $inView }) => ($inView ? "1" : "0")};
    transition-delay: 0.3s;
  }
`
const StyledToolCol = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 50px;
`

const StyledSwiper = styled(Swiper)`
  width: 100%;
  overflow: visible;
  .swiper-wrapper {
    width: fit-content;
    margin: 0px auto;
  }
  /* padding: 60px; */
  /* max-width: calc(1920px - 100px - 100px); */
`
const StyledSwiperSlide = styled(SwiperSlide)<{ $inView: boolean }>`
  width: max-content;
  box-sizing: border-box;
  ${(p) => p.theme.breakpoints.up("md")} {
    height: auto;
    &:nth-child(4) {
      transform: ${({ $inView }) =>
        !$inView ? "translateX(-10%)" : "translateX(0)"};
      opacity: ${({ $inView }) => ($inView ? "1" : "0")};
    }
    &:nth-child(3) {
      transform: ${({ $inView }) =>
        !$inView ? "translateX(-110%)" : "translateX(0)"};
      opacity: ${({ $inView }) => ($inView ? "1" : "0")};
    }
    &:nth-child(2) {
      transform: ${({ $inView }) =>
        !$inView ? "translateX(-210%)" : "translateX(0)"};
      opacity: ${({ $inView }) => ($inView ? "1" : "0")};
    }
    &:nth-child(1) {
      transform: ${({ $inView }) =>
        !$inView ? "translateX(-310%)" : "translateX(0)"};
      opacity: ${({ $inView }) => ($inView ? "1" : "0")};
    }

    transition: all 0.9s 0.9s cubic-bezier(0.19, 0.88, 0.53, 1.12);
    transition-delay: 0.3s;
  }
`
type MazdaToolsProps = {
  toolsData: ModelPromoted[]
}

const MazdaTools = ({ toolsData }: MazdaToolsProps) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
  })

  return (
    <div ref={ref}>
      <StyledWrapperContainer $inView={inView}>
        <Mobile>
          <StyledToolCol>
            {toolsData.map((item) => (
              <ToolsCard key={item.id} toolsData={item} />
            ))}
          </StyledToolCol>
        </Mobile>
        <Desktop>
          <StyledSwiper
            modules={[A11y, Keyboard]}
            initialSlide={1}
            allowTouchMove={true}
            grabCursor={true}
            slidesPerView="auto"
            spaceBetween={20}
            slideToClickedSlide={true}
            keyboard={{
              enabled: true,
            }}
          >
            {toolsData.map((item, index) => {
              return (
                <StyledSwiperSlide
                  $inView={inView}
                  key={`swiper-tools-${index}`}
                >
                  <ToolsCard key={item.id} toolsData={item} />
                </StyledSwiperSlide>
              )
            })}
          </StyledSwiper>
        </Desktop>
      </StyledWrapperContainer>
    </div>
  )
}

export default MazdaTools
